import {Injectable} from '@angular/core';
import {GenericService} from "../commons/generic.service";
import {Role} from "../domain/role";
import {QueryOptions} from "../commons/query.options";
import {AuthService} from "../security/auth.service";
import {FX} from "../domain/fx";
import {RequestMethod} from "@angular/http";
import {Observable} from "rxjs/Observable";
import { PaginationPage } from "app/core/commons/pagination-page";

@Injectable()
export class RoleService extends GenericService<Role> {

    private resourcePath: string = "/role";

    constructor(authService: AuthService) {
        super(authService);
    }

    public findByFxs(fxs: FX[]): Observable<Role[]> {
        let req = this.buildRequest(RequestMethod.Post, JSON.stringify(fxs));
        return this.authService.authRequest(this.baseUrl + this.getResourcePath() + "/for_fxs", req)
            .map(res => res.json().map(role => this.valueToEntity(role)));
    }

    protected valueToEntity(value: Object): Role {
        return new Role(value);
    }

    protected getResourcePath(): string {
        return this.resourcePath;
    }

    getDefaultQueryOptions(): QueryOptions {
        return new QueryOptions();
    }

    public getPage(
        queryOptions: QueryOptions = this.getDefaultQueryOptions()
      ): Observable<PaginationPage<Role>> {
        const ro = queryOptions.getQueryRequestOptions().merge({
          url: this.baseUrl + this.getResourcePath() + ""
        });
        return this.doRequest(ro)
          .map(res => res.json())
          .concatMap(json =>
            Observable.from(json.content)
              .concatMap(value => this.mapValueToEntityQuery(value))
              .toArray()
              .map(content => new PaginationPage({ ...json, content: content }))
          );
      }

}



// WEBPACK FOOTER //
// ./src/app/core/service/role.service.ts